import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { ContainerQueryContext, ContainerQueryProps } from './ContainerQueryProvider';

function withContainerQuery<IncomingProps>(Component: React.ComponentType<IncomingProps & ContainerQueryProps>) {
  const wrapper = (props: IncomingProps) => {
    return (
      <ContainerQueryContext.Consumer>
        {(value) => (
          <Component {...props} device={value} />
        )}
      </ContainerQueryContext.Consumer>
    );
  };

  return hoistNonReactStatics(wrapper, Component);
}

export default withContainerQuery;
